var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTablerIconShoppingCartOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 76C16 78.1217 16.8429 80.1566 18.3431 81.6569C19.8434 83.1571 21.8783 84 24 84C26.1217 84 28.1566 83.1571 29.6569 81.6569C31.1571 80.1566 32 78.1217 32 76C32 73.8783 31.1571 71.8434 29.6569 70.3431C28.1566 68.8429 26.1217 68 24 68C21.8783 68 19.8434 68.8429 18.3431 70.3431C16.8429 71.8434 16 73.8783 16 76Z",
    stroke: "#5F7586",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 68C66.4178 68 64.871 68.4692 63.5554 69.3482C62.2399 70.2273 61.2145 71.4767 60.609 72.9385C60.0035 74.4003 59.845 76.0089 60.1537 77.5607C60.4624 79.1126 61.2243 80.538 62.3432 81.6569C63.462 82.7757 64.8874 83.5376 66.4393 83.8463C67.9911 84.155 69.5997 83.9965 71.0615 83.391C72.5233 82.7855 73.7727 81.7602 74.6518 80.4446C75.5308 79.129 76 77.5823 76 76",
    stroke: "#5F7586",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 68H24V24",
    stroke: "#5F7586",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.956 20.924L80 24L76 52H68M52 52H24",
    stroke: "#5F7586",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L84 84",
    stroke: "#F93549",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconShoppingCartOff);
export default __webpack_public_path__ + "static/media/tabler-icon-shopping-cart-off.75b407c5b23599d53a63e729961bd86e.svg";
export { ForwardRef as ReactComponent };